import { Button } from "@material-ui/core";
import React from "react";


function Shop() {
  return (
    <div >
      This is Shop component
      <Button
      onClick={()=>{
        window.location.href="/"
      }}
      >
        back
      </Button>
    </div>
  );
}

export default Shop;
